/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SuperscriptIcon = /*#__PURE__*/ createSvgIcon(
  'SuperscriptIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              d="M12 1.361c.213-.265.476-.478.771-.627.295-.148.616-.228.942-.234.19-.003.38.035.556.112.177.076.338.19.473.334.135.144.242.316.315.505.073.189.11.392.11.596 0 .985-.58 1.41-2.75 3.697V6.5H16"
              stroke="currentColor"
              strokeMiterlimit={10}
            />
            <path
              d="M.112 3.5l4.245 6.125L0 15.912V16h1.155l3.81-5.497L8.775 16H9.96l.02-.015-4.407-6.36L9.818 3.5H8.6L4.965 8.747 1.329 3.5H.112z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              d="M15 1.505A2.908 2.908 0 0117.148.5a1.797 1.797 0 011.822 1.805c0 1.15-.727 1.646-3.447 4.313V7.5h4.492"
              stroke="currentColor"
              strokeMiterlimit={10}
            />
            <path
              d="M.077 4l5.545 8-5.545 8h1.217l4.936-7.122L11.166 20h1.217l-5.545-8 5.545-8h-1.217L6.23 11.122 1.294 4H.077z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              d="M18 1.74A3.56 3.56 0 0120.63.51a2.2 2.2 0 012.23 2.21c0 1.407-.89 2.015-4.22 5.28v1.08h5.5"
              stroke="currentColor"
              strokeMiterlimit={10}
            />
            <path
              d="M.226 4.5l6.756 9.755L.232 24H1.45l6.14-8.867L13.732 24h1.216l-6.749-9.745L14.954 4.5h-1.216L7.59 13.377 1.442 4.5H.226z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default SuperscriptIcon;
